<template>
  <div class="wrapper-full">
    <table class="wrapper-full">
      <tbody class="wrapper-full">
        <tr class="wrapper-full" style="height: 30px; font-size: 20px; white-space: pre-line">
          <td colspan="2">{{ title }}</td>
        </tr>
        <tr class="wrapper-full">
          <td
            :style="`width: ${isOrthokeratology ? '50%' : isDE ? '40%' : '45%'}; vertical-align: top`"
          >
            <el-input
              v-for="item in inputList"
              :key="item.key"
              v-model="item.val"
              @click.native.stop.prevent="handleClick(item)"
              @touchend.native.stop.prevent="handleClick(item)"
              style="font-size: 20px"
            >
              <template slot="prepend"
                ><p
                  :style="`min-width: ${isOrthokeratology ? (isDE ? '450px' : isIT ? '475px' : '220px') : isDE ? '202px' : '220px'};`"
                >
                  {{ item.label }}:
                </p>
              </template>
            </el-input>
          </td>
          <td
            :style="`width: ${isOrthokeratology ? '50%' : isDE ? '60%' : '55%'}; vertical-align: top`"
          >
            <el-input
              v-for="item in outputList"
              :key="item.key"
              :minlength="400"
              v-model="item.val"
              disabled
            >
              <template slot="prepend"
                ><p
                  :style="`min-width: ${isOrthokeratology ? (isDE ? '450px' : isIT ? '475px' : '220px') : isDE ? '370px' : '300px'}`"
                >
                  {{ item.label }}:
                </p>
              </template>
            </el-input>
            <div style="margin-top: 30px">
              <el-button @click="calc">{{ $t("langcfg.txtCalculate") }}</el-button>
              <el-button @click="clear">{{ $t("langcfg.txtClear") }}</el-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import EVENTS from "../../bus";
import { Message } from "../../mixins";
import RgpApi from "../js/RGPAPI";

export default {
  name: "ContenctLensTable",
  mixins: [Message],
  data() {
    return {
      isDE: false,
      isIT: false
    };
  },
  mounted() {
    this.isDE = window.settings.language === "de";
    this.isIT = window.settings.language === "it";
  },
  updated() {
    this.isDE = window.settings.language === "de";
    this.isIT = window.settings.language === "it";
  },
  methods: {
    handleClick(item) {
      this.$bus.$emit(EVENTS.spreadKeyBoard, item.val, (value) => {
        item.val = value;
      });
    },
    handleClick1(item) {
      this.$bus.$emit(EVENTS.spreadKeyBoard, item.val, (value) => {
        item.val = value;
      });
    },
    calc() {
      let arrParams = new Array(this.inputList.length);
      for (let i = 0; i < arrParams.length; i++) {
        let tmp = parseFloat(this.inputList[i].val);
        if (isNaN(tmp)) {
          this.notify(this.$t("langcfg.txtInputValidValue"), "", "error", 3000);
          return;
        }
        arrParams[i] = tmp;
      }
      let output = new Float64Array(this.outputList.length);
      let result = RgpApi[`${this.calFunc}`](...arrParams, output);
      if (this.calFunc === "okLensRecommend")
        output = [output[0], output[1], output[2], output[4], output[3]];
      if (result) {
        this.notify(this.$t("langcfg.txtCalcSuccess"), "", "success", 3000);
        for (let i = 0; i < this.outputList.length; i++) {
          this.outputList[i].val = output[i]._toFixed(2);
        }
      } else {
        this.notify(this.$t("langcfg.txtCalcSuccess"), "", "error", 3000);
        for (let i = 0; i < this.outputList.length; i++) {
          this.outputList[i].val = "--";
        }
      }
    },
    clear() {
      for (let i = 0; i < this.inputList.length; i++) {
        this.inputList[i].val = "";
      }
      for (let i = 0; i < this.outputList.length; i++) {
        this.outputList[i].val = "";
      }
    }
  },
  props: {
    inputList: {
      type: Array,
      default: () => []
    },
    outputList: {
      type: Array,
      default: () => []
    },
    title: "",
    calFunc: {
      type: String,
      required: true
    },
    isOrthokeratology: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped>
.el-button {
  width: 45%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
  border: 1px solid gray;
  height: 50px;
  margin-left: 10px;
}
.el-input /deep/ .el-input__inner {
  font-size: 25px;
}
p {
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ContenctLensTable.vue